module.exports = __webpack_public_path__ + "img/tzright.65ed7c47.svg";